module.exports = __webpack_public_path__ + "assets/images/premium-features/timeclock-banner-new-f19bc2.png";